"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstagramLogo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "5", fill: "black", stroke: "black", strokeWidth: "2" }, void 0),
            jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z", fill: "white" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "17", cy: "7", r: "1", fill: "white" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "3.99996", y: "3.99996", width: "24", height: "24", rx: "6.66667", fill: "black", stroke: "black", strokeWidth: "2.66667" }, void 0),
            jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 22.6667C19.6819 22.6667 22.6667 19.6819 22.6667 16C22.6667 12.3181 19.6819 9.33337 16 9.33337C12.3181 9.33337 9.33337 12.3181 9.33337 16C9.33337 19.6819 12.3181 22.6667 16 22.6667ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z", fill: "white" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "22.6667", cy: "9.33333", r: "1.33333", fill: "white" }, void 0)] }), void 0));
};
var InstagramLogo = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.InstagramLogo = InstagramLogo;
//# sourceMappingURL=InstagramLogo.js.map